export { localStorageGetItem } from './local-storage-get-item';
export { localStorageSetItem } from './local-storage-set-item';
export { sessionStorageGetItem } from './session-storage-get-item';
export { sessionStorageSetItem } from './session-storage-set-item';
export { clearStorage } from './clear-storage';
